module.exports = "/public/images/a573f48c94eaced15a5f4f3abc61e58e.png";